import { jsx as _jsx } from "react/jsx-runtime";
import cn from "variant-classnames";
const variants = {
    $all: "flex w-full flex-col",
    spacing: {
        xs: "gap-1",
        sm: "gap-2",
        md: "gap-4",
        lg: "gap-6",
        xl: "gap-8",
    },
};
/**
 * A flex container that applies spacing between the child elements.
 *
 * @component
 *
 * @param {IFlexListProps} props The props for the FlexList component.
 * @param {string} [props.className] The CSS class to apply to the component.
 * @param {("sm"|"md"|"lg"|"xl")} [props.spacing="sm"] The amount of spacing to apply between child elements.
 * @returns {JSX.Element} The rendered `FlexList` component.
 */
const FlexList = ({ children, className, spacing = "sm", ...rest }) => {
    const classes = cn(variants, { className, spacing });
    return (_jsx("div", { ...rest, className: classes, children: children }));
};
export default FlexList;
//# sourceMappingURL=FlexList.js.map